import NotificationItem from 'shared/components/notifications/notification_item';
import $ from 'jquery';

export default class NotificationFollowing {
  constructor(options = {}){
    this.uiParent = 'div.notifications';
    this.uiRoot = '.activity-list--following';
    this.ujsFollowing = 'a.notifications__ujs--following';

    this.parent = options.parent;
  }

  init(){
    this.bindUJSFollowing()
  }

  bindUJSFollowing(){
    $(document).on('ajax:success', this.ujsFollowing, function(event){
      let data = event.detail[0];
      this.render(data);
    }.bind(this));
  }

  render(data) {
    this.setLoaded(true); 
    this.setCount(data.length);

    if(this.count() > 0){
      this.addCollection(data);
    }
  }

  add(notification) {
    const item = NotificationItem.new(notification);
    $(this.uiRoot).append(item.html);
  }

  addCollection(notifications) {
    for(const index in notifications){
      const notification = notifications[index];
      this.add(notification);
    }
  }

  count() {
    return $(this.uiParent).data("followingCount");
  }

  setCount(value) {
    $(this.uiParent).attr("data-following-count", value);
  }

  loaded() {
    return $(this.uiParent).data('followingLoaded');
  }

  setLoaded(value) {
    $(this.uiParent).attr("data-following-loaded", value);
  }

  load() {
    if (!this.loaded()) {
      this.setLoaded("false");
      this.triggerUJSFollowing();
    }
  }

  triggerUJSFollowing() {
    $(this.ujsFollowing)[0].click();
  }
}
